export default "data:image/webp;base64,UklGRkAAAABXRUJQVlA4TDMAAAAvJ8AEAFAUgAykgDRaSiLrzi9Bts38MQYxl2ucgCDbZgyjmMB9j9r/xHyXrkz8XVdZzrsA"